import $ from 'jquery';
import moment from 'moment/moment';

import { siteModel } from 'models/SiteModel';

import MustacheComponent from '@components/mustache-component';
import storageManager from '@utils/storage-manager';

const dynamic = {
    header: '#c-header-ajax-content',
    comments: '#c-comments',
};

const templates = {
    anonymous: '#mustache-header-anonymous',
    authenticated: '#mustache-header-authenticated',
    comments: '#mustache-comments',
};

class MustacheContent
{
    getUser() {
        if (siteModel.isUserLogged()) {

            const user = siteModel.get('User');
            return  {
                authenticated: true,
                id: user.get('id'),
                username: user.get('username'),
                email: user.get('email'),
                displayName: user.get('displayName'),
                thumbnail: user.get('thumbnail'),
                premium: user.get('premium'),
                type: user.get('type'),
                isModerator: user.get('isModerator'),
                isBanned: user.get('isBanned'),
                banEndsAt: user.get('banEndsAt'),
                areAdditionalSettingsEnabled: user.get('areAdditionalSettingsEnabled'),
                darkMode: user.get('hasDarkMode'),
            };
        }
        return {
            authenticated: false,
        };
    }

    handleForms() {
        const darkModeForm = $("form[name=premium_dark_mode_form]");
        const darkModeCheckbox = $("#dark-mode-checkbox");

        darkModeCheckbox.on("change", function (event) {
            if (darkModeForm) {
               storageManager.setDarkMode(event.target.checked);
                darkModeForm.submit();
            }
        });
    }

    handleLogout() {
        const element = $(".sun-logout");
        element.on("click", function (event) {
            storageManager.clearDarkMode();
        });
    }

    renderHeader() {
        const data = {
            user: this.getUser(),
        };
        const template = siteModel.isUserLogged() ? templates.authenticated : templates.anonymous;

        const mustache = new MustacheComponent($(template));
        mustache.set(data);

        const html = mustache.render();
        $(dynamic.header).append(html);
        this.handleForms();
        this.handleLogout();

    }

    renderCommentsSection() {
        const user = this.getUser();
        const data = {
            user,
        };

        if (user.banEndsAt) {
            data.banEndsCounter = moment(user.banEndsAt.date).fromNow();
        }

        const mustache = new MustacheComponent($(templates.comments));
        mustache.set(data);

        const html = mustache.render();
        $(dynamic.comments).html(html);
    }
}

export const mustacheContent = new MustacheContent();

export default {
    init() {
        $(document).ready(() => {
            /**
             * Create mustache component and render header
             */
            mustacheContent.renderHeader();
        });
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/mustache-content/index.js